var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.list),function(item,index){return _c('img',{key:index,attrs:{"alt":"","src":_vm.img.src}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }